import React from 'react';
import PropTypes from 'prop-types';
import style from './DataList.module.css';

function DataList({
  children,
  dataList,
  dataMapFunc,
  inputHandler,
  inputVal,
  id,
  ref,
  onBlur,
}) {
  return (
    <>
      <input
        className={style.input}
        list={id}
        id={children}
        name={children}
        value={inputVal}
        onChange={({ target }) => inputHandler(target.value)}
        placeholder={children}
        ref={ref}
        onBlur={onBlur}
      />

      <datalist id={id}>{dataList.map(dataMapFunc)}</datalist>
    </>
  );
}
DataList.defaultProps = {
  onBlur: () => {},
};
DataList.propTypes = {
  children: PropTypes.string,
  dataList: PropTypes.array.isRequired,
  dataMapFunc: PropTypes.func.isRequired,
  inputHandler: PropTypes.func.isRequired,
  inputVal: PropTypes.string.isRequired,
  ref: PropTypes.element,
  id: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
};

export default DataList;
